import React, { useState } from 'react';
import { BoxProps } from '@components/Box';
import { Flex } from '@components/Flex';
import {
  PlanTogetherText,
  PlanTogetherWrapper,
  StyledFlexContainer,
  StyledImage,
  StyledTextContainer,
  DesktopLazyLoadWrapper,
  MobileLazyLoadWrapper,
  StyledPlaceholderCloudImage,
  StyledPlaceholderCloudImageMobile,
} from './PlanTogetherSection.styles';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { useTranslation } from 'react-i18next';

interface PlanTogetherSectionProps {
  backgroundColor?: BoxProps['backgroundColor'];
}

export const PlanTogetherSection: React.FC<PlanTogetherSectionProps> = ({ backgroundColor }) => {
  const sectionId = 'Wedding_Websites_Multiple_Editors';
  const [isVisible, setIsVisible] = useState(false);
  const [isVisibleMobile, setIsVisibleMobile] = useState(false);

  const { t } = useTranslation('sections');
  const planTogetherSectionData = t('planTogetherSection');

  return (
    <PlanTogetherWrapper as={'section'} paddingTop={[14]} paddingBottom={[12]} backgroundColor={backgroundColor} id={sectionId}>
      <DesktopLazyLoadWrapper>
        <LazyLoadWrapper beforeLoad={() => setIsVisible(true)}>
          <div />
        </LazyLoadWrapper>
      </DesktopLazyLoadWrapper>
      <MobileLazyLoadWrapper>
        <LazyLoadWrapper beforeLoad={() => setIsVisibleMobile(true)}>
          <div />
        </LazyLoadWrapper>
      </MobileLazyLoadWrapper>
      <Flex flexDirection={'column'}>
        <StyledFlexContainer flexDirection={['column', 'row', 'row']} alignContent="center">
          <Flex flexDirection={'column'}>
            <StyledImage id="ConnectedGuestList">
              <StyledPlaceholderCloudImage
                alt="PlanTogether"
                src={planTogetherSectionData.image}
                width={600}
                isMainSrcShown={isVisible}
                optimization="default"
              />
              <StyledPlaceholderCloudImageMobile
                alt="PlanTogether"
                src="sitewide/block_multiple-editors/ww-multiple-editors-mobile.png"
                width={363}
                mobileResizeWidth={363}
                isMainSrcShown={isVisibleMobile}
                optimization="default"
              />
            </StyledImage>
          </Flex>
          <StyledTextContainer justifyContent="center" alignItems="center" marginRight="30px">
            <PlanTogetherText
              eyebrow={planTogetherSectionData.eyebrow}
              eyebrowTagName="h2"
              eyebrowColor="humana3"
              eyebrowVariant="sectionEyeBrow24"
              title={planTogetherSectionData.title}
              titleVariant="hed56"
              titleColor="blue2"
              titleTagName="h2"
              body={planTogetherSectionData.content}
              bodyPaddingRight="180px"
              bodyColor="blue2"
              bodyVariant="dek20"
            />
          </StyledTextContainer>
        </StyledFlexContainer>
      </Flex>
    </PlanTogetherWrapper>
  );
};
